import { useMemo } from "react";

/** Simple SVG bar chart. data = [{label, values: [n1, n2, n3]}]. seriesLabels + colors indexed. */
export default function BarChart({ data, seriesLabels = [], colors = ["#0f172a", "#0891b2", "#059669"], height = 240, formatValue = (v) => v }) {
  const max = Math.max(1, ...data.flatMap((d) => d.values));
  const W = 800, H = height, pad = { l: 44, r: 12, t: 20, b: 40 };
  const cw = (W - pad.l - pad.r) / (data.length || 1);
  const bw = (cw - 6) / (seriesLabels.length || 1);
  const ticks = useMemo(() => Array.from({ length: 5 }, (_, i) => (max * i) / 4), [max]);

  return (
    <div className="w-full overflow-x-auto">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ minWidth: 480 }}>
        {/* y ticks */}
        {ticks.map((t) => {
          const y = H - pad.b - ((H - pad.b - pad.t) * t) / max;
          return (
            <g key={`t-${t}`}>
              <line x1={pad.l} y1={y} x2={W - pad.r} y2={y} stroke="#e2e8f0" />
              <text x={pad.l - 6} y={y + 4} textAnchor="end" fontSize="10" fill="#64748b" fontFamily="IBM Plex Mono, monospace">{formatValue(t)}</text>
            </g>
          );
        })}
        {/* bars */}
        {data.map((d, i) => (
          <g key={`c-${d.label ?? i}`}>
            {d.values.map((v, j) => {
              const x = pad.l + i * cw + 3 + j * bw;
              const h = ((H - pad.b - pad.t) * v) / max;
              const y = H - pad.b - h;
              return <rect key={`b-${d.label ?? i}-${seriesLabels[j] ?? j}`} x={x} y={y} width={Math.max(1, bw - 2)} height={h} fill={colors[j % colors.length]} />;
            })}
            <text x={pad.l + i * cw + cw / 2} y={H - pad.b + 14} textAnchor="middle" fontSize="10" fill="#475569">{d.label}</text>
          </g>
        ))}
        {/* legend */}
        {seriesLabels.map((s, i) => (
          <g key={`l-${s}`} transform={`translate(${pad.l + i * 100}, 12)`}>
            <rect width="10" height="10" fill={colors[i % colors.length]} />
            <text x="14" y="9" fontSize="10" fill="#334155">{s}</text>
          </g>
        ))}
      </svg>
    </div>
  );
}
